export default "__VITE_ASSET__DHOq9UZS__"